let module = {
  toMoneyTh: function (val) {
    return this.toMoney(val).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
  },
  toMoney: function(val, dft = '--') { //把金额格式化为 元.角分
  	if (val === null || typeof val === 'undefined' || val === '') {
      return dft;
    }
    val = val.toString();
    var mSymbol = "";
    if (!!val && (val.substr(0, 1) == "-" || val.substr(0, 1) == "+")) {
      mSymbol = val.substr(0, 1);
      val = val.substr(1, val.length - 1);
    }
    var arrayVal = val.toString().replace(/,/g, '');
    arrayVal = arrayVal.split(".");
    if (arrayVal[1] == undefined) {
      arrayVal[1] = "00";
    }
    var num = (arrayVal[0]) ? arrayVal[0].toString() : '',
      cent = (typeof arrayVal[1] != "undefined") ? "." + arrayVal[1] : "",
      moneyNum = '',
      result = '';
    cent = cent.substr(0, 3);
    while (num.length > 3) {
      moneyNum = ',' + num.slice(-3) + moneyNum;
      num = num.slice(0, num.length - 3);
    }
    if (num) {
      result = num + moneyNum + cent;
    }
    return mSymbol + result;
  },
  toCh: function(val) { // 金额转成中文数字
    var maxDec = 2;
    // 验证输入金额数值或数值字符串：
    val = val.toString().replace(/,/g, "");
    val = val.replace(/^0+/, ""); // 金额数值转字符、移除逗号、移除前导零
    if (val == "") {
      return "零元整";
    } // （错误：金额为空！）
    else if (isNaN(val)) {
      return "错误：金额不是合法的数值！";
    }
    var minus = ""; // 负数的符号“-”的大写：“负”字。可自定义字符，如“（负）”。
    var CN_SYMBOL = ""; // 币种名称（如“人民币”，默认空）
    if (val.length > 1) {
      if (val.indexOf('-') == 0) {
        val = val.replace("-", "");
        minus = "负";
      } // 处理负数符号“-”
      if (val.indexOf('+') == 0) {
        val = val.replace("+", "");
      } // 处理前导正数符号“+”（无实际意义）
    }
    // 变量定义：
    var vInt = "";
    var vDec = "";
    var resAIW;
    var parts;
    var digits,
      radices,
      bigRadices,
      decimals;
    var zeroCount;
    var i,
      p,
      d;
    var quotient,
      modulus;
    var NoneDecLen = (typeof(maxDec) == "undefined" || maxDec == null || Number(maxDec) < 0 || Number(maxDec) > 5); // 是否未指定有效小数位（true/false）
    parts = val.split('.');
    if (parts.length > 1) {
      vInt = parts[0];
      vDec = parts[1];
      if (NoneDecLen) {
        maxDec = vDec.length > 5 ? 5 : vDec.length;
      }
      var rDec = Number("0." + vDec);
      rDec *= Math.pow(10, maxDec);
      rDec = Math.round(Math.abs(rDec));
      rDec /= Math.pow(10, maxDec);
      var aIntDec = rDec.toString().split('.');
      if (Number(aIntDec[0]) == 1) {
        vInt = (Number(vInt) + 1).toString();
      }
      if (aIntDec.length > 1) {
        vDec = aIntDec[1];
      } else {
        vDec = "";
      }
    } else {
      vInt = val;
      vDec = "";
      if (NoneDecLen) {
        maxDec = 0;
      }
    }
    if (vInt.length > 44) {
      return "错误：金额值太大了！整数位长【" + vInt.length.toString() + "】超过了上限——44位/千正/10^43（注：1正=1万涧=1亿亿亿亿亿，10^40）！";
    }
    digits = new Array("零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖");
    radices = new Array("", "拾", "佰", "仟");
    bigRadices = new Array("", "万", "亿", "兆", "京", "垓", "杼", "穰", "沟", "涧", "正");
    decimals = new Array("角", "分", "厘", "毫", "丝");
    resAIW = "";
    if (Number(vInt) > 0) {
      zeroCount = 0;
      for (i = 0; i < vInt.length; i++) {
        p = vInt.length - i - 1;
        d = vInt.substr(i, 1);
        quotient = p / 4;
        modulus = p % 4;
        if (d == "0") {
          zeroCount++;
        } else {
          if (zeroCount > 0) {
            resAIW += digits[0];
          }
          zeroCount = 0;
          resAIW += digits[Number(d)] + radices[modulus];
        }
        if (modulus == 0 && zeroCount < 4) {
          resAIW += bigRadices[quotient];
        }
      }
      resAIW += "元";
    }
    for (i = 0; i < vDec.length; i++) {
      d = vDec.substr(i, 1);
      if (d != "0") {
        resAIW += digits[Number(d)] + decimals[i];
      }
    }
    if (resAIW == "") {
      resAIW = "零" + "元";
    }
    if (vDec == "") {
      resAIW += "整";
    }
    resAIW = CN_SYMBOL + minus + resAIW;
    return resAIW;
  },
  formatNumber:function(num, cent, isThousand){
      //@param num 数值(Number或者String)
      //@param cent 要保留的小数位(Number)
      // @param isThousand 是否需要千分位 0:不需要,1:需要(数值类型);
      num = num.toString().replace(/\$|\,/g, '');
      // 检查传入数值为数值类型
      if (isNaN(num))
          num = "0";
      // 获取符号(正/负数)
      let sign = (num == (num = Math.abs(num)));
      num = Math.floor(num * Math.pow(10, cent) + 0.50000000001);  // 把指定的小数位先转换成整数.多余的小数位四舍五入
      let cents = num % Math.pow(10, cent);              // 求出小数位数值
      num = Math.floor(num / Math.pow(10, cent)).toString();   // 求出整数位数值
      cents = cents.toString();               // 把小数位转换成字符串,以便求小数位长度
      // 补足小数位到指定的位数
      while (cents.length < cent)
          cents = "0" + cents;
      if (isThousand) {
          // 对整数部分进行千分位格式化.
          for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++)
              num = num.substring(0, num.length - (4 * i + 3)) + ',' + num.substring(num.length - (4 * i + 3));
      }

      if (cent > 0)
          return (((sign) ? '' : '-') + num + '.' + cents);
      else
          return (((sign) ? '' : '-') + num);
  }
};
export default module;


// WEBPACK FOOTER //
// ./src/assets/utils/money-fmt.js